<template> 
  <div 
    class="swap-number-toggle rounded-full p-2 pr-1"
    :class="{'active': value}"
    @click="troggle"
  >
    <div class="group relative mr-3 cursor-pointer">
      <input
        type="checkbox"
        class="sr-only"
        value="props.modelValue"
      ><div class="flex items-center gap-2 text-base font-medium">
        <div 
          class="block h-7 w-12 rounded-full border border-gray-200 transition ease-in-out bg-gray-600 group-hover:bg-gray-700"
          :class="{
            'bg-gray-600': !value,
            'bg-primary': value
          }"
        ></div>
        <div 
          class="absolute flex h-5 w-5 transform items-center justify-center rounded-full border border-gray-200 bg-white transition ease-in-out"
          :class="{
            'left-1': !value,
            'left-2': value
          }"
        ></div>
        <span class="text-xl">กลับเลข</span>
      </div>
    </div>
  </div>
</template>
<script>   
export default { 
  props:{
    value: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    troggle () {
      this.$emit('change')
    }
  }
}
</script>
<style scoped>
.swap-number-toggle.active {
  --tw-text-opacity: 1;
  /* background: radial-gradient(ellipse at center top, #fbefe7, #ffe6d3, #fbefe7); */
  background: white;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.swap-number-toggle {
  --tw-text-opacity: 1;
  background: radial-gradient(ellipse at center top, #383838, #171717);
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.sr-only {
  height: 1px !important;
  margin: -1px !important;
  overflow: hidden !important;
  padding: 0 !important;
  position: absolute !important;
  width: 1px !important;
  clip: rect(0, 0, 0, 0) !important;
  border-width: 0 !important;
  white-space: nowrap !important;
}

.bg-white {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255/ 1) !important;
}

.border-gray-200 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(229 231 235/ 1) !important;
}

.bg-gray-600 {
    background-color: rgb(75 85 99/ 1) !important;
}

.border {
  border-width: 1px !important;
}

.ease-in-out {
  transition-timing-function: cubic-bezier(.4,0,.2,1) !important;
}

.transition {
  transition-duration: .15s !important;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter !important;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter !important;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter !important;
  transition-timing-function: cubic-bezier(.4,0,.2,1) !important;
}

.relative {
  position: relative !important;
}

.absolute {
  position: absolute !important;
}

.w-12 {
  width: 3rem !important;
}

.h-7 {
  height: 1.75rem !important;
}

.left-1 {
  left: .25rem !important;
}

.left-2 {
  left: 1.5rem !important;
}

.bg-primary {
  --tw-bg-opacity: 1 !important;
  background-color: var(--bg-secondary-color-v2) !important;
}

.translate-x-full {
    --tw-translate-x: 100% !important;
}

.translate-x-full {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
</style>